import Icon from '../components/Icon.vue'

Icon.register({
  'compact-disc': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM88 256c0-88.2 71.8-160 160-160v-32c-105.9 0-192 86.1-192 192h32zM248 352c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zM248 224c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32z'
      }
    ]
  }
})
